import dayjs from 'dayjs'
import { formatMoneyRMG } from '@/utils/helpers/inputHelper'
import { WhatsappApiBalance, WhatsappApiMessage } from '@/types/whatsappApi'

export const formatRp = (amount: number) =>
  formatMoneyRMG(Math.abs(amount), 'Rp') as string

export const formatSignedRp = (amount: number) =>
  `${amount > 0 ? '+' : '−'}${formatRp(amount)}`

export const isSkippedStatus = (status: string) => status.startsWith('SKIPPED')

export type BalanceState = 'normal' | 'low' | 'empty' | 'unavailable'

// Free quota is consumed first, so the balance only matters once it is used up
export const getBalanceState = (data?: WhatsappApiBalance): BalanceState => {
  if (!data) return 'normal'
  if (data.channelEnabled === false) return 'unavailable'
  if ((data.freeQuota?.remaining ?? 0) > 0) return 'normal'
  const price = data.pricePerMessage || 0
  if (data.balance < price || data.balance <= 0) return 'empty'
  const threshold = data.lowBalanceThreshold ?? price * 3
  if (data.balance < threshold) return 'low'
  return 'normal'
}

export const getMessageCost = (
  message: WhatsappApiMessage,
  freeLabel: string,
) => {
  if (isSkippedStatus(message.status) || message.status === 'FAILED') {
    return '—'
  }
  if (message.chargeSource === 'FREE') return freeLabel
  return formatRp(message.priceIdr)
}

export const formatDateTime = (value?: string | null) =>
  value ? dayjs(value).format('DD MMM YYYY, HH:mm') : '-'

export const getDateRange = (range?: string) => {
  const today = dayjs()
  switch (range) {
    case 'today':
      return {
        from: today.format('YYYY-MM-DD'),
        to: today.format('YYYY-MM-DD'),
      }
    case '30d':
      return {
        from: today.subtract(29, 'day').format('YYYY-MM-DD'),
        to: today.format('YYYY-MM-DD'),
      }
    default:
      return {
        from: today.subtract(6, 'day').format('YYYY-MM-DD'),
        to: today.format('YYYY-MM-DD'),
      }
  }
}
